import type { Organization } from "@rulebase/core/api";
import { queryOptions } from "@tanstack/react-query";
import { rulebaseApi2Request } from "@/lib/rulebase-api2-client/client";

type Session = {
  account_id: string;
  organization_id: string | null;
  account: { id: string; full_name: string; email: string };
};

export function getSessionQueryOptions() {
  return queryOptions({
    queryKey: ["session"],
    queryFn: () => rulebaseApi2Request<Session>("/session"),
  });
}

/**
 * The session only carries the organization id, so the workspace name needs a
 * second read. Enabled by the caller once the session has resolved.
 */
export function getOrganizationQueryOptions(organizationId: string) {
  return queryOptions({
    queryKey: ["organizations", organizationId],
    queryFn: () => rulebaseApi2Request<{ data: Organization }>("/organization"),
  });
}
